import { Tooltip } from '@mantine/core'
import styles from '../../styles/admin/List.module.scss'
import { ClassListProps } from '../../types/list'

const ClassListItem = ({
  level,
  mainChapter,
  subChapter,
  unit,
  detailUnit,
  no,
  contentType,
  questionLabel,
  modify,
  deleteAction,
}: ClassListProps) => {
  const truncateText = (text: string, maxLength: number = 8) => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
  }

  const shouldShowTooltip: (
    text: string | null | undefined,
    maxLength?: number
  ) => boolean = (text: string | null | undefined, maxLength: number = 8) => {
    if (!text) return false
    return text.length > maxLength
  }

  const renderCellWithTooltip = (
    content: string | null | undefined,
    maxLength: number = 15
  ) => {
    if (!content) return <span>-</span>

    if (shouldShowTooltip(content, maxLength)) {
      return (
        <Tooltip label={content} withArrow>
          <span>{truncateText(content, maxLength)}</span>
        </Tooltip>
      )
    }
    return <span>{content}</span>
  }

  return (
    <div className={styles.listItem} style={{ width: '20px' }}>
      <div className={styles.cell}>{renderCellWithTooltip(level)}</div>
      <div className={styles.cell}>{renderCellWithTooltip(mainChapter)}</div>
      <div className={styles.cell}>{renderCellWithTooltip(subChapter)}</div>
      <div className={styles.cell}>{renderCellWithTooltip(unit)}</div>
      <div className={styles.cell}>
        {renderCellWithTooltip(detailUnit?.toString() || '0')}
      </div>
      <div className={styles.cell}>
        {renderCellWithTooltip(no?.toString() || '0')}
      </div>
      <div className={styles.cell}>{contentType}</div>
      <div className={styles.cell}>{renderCellWithTooltip(questionLabel)}</div>
      <div className={styles.cell}>{modify}</div>
      <div className={styles.cell}>{deleteAction}</div>
    </div>
  )
}

export default ClassListItem
